import { useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useHRM3040_R01Store } from "./Store_HRM3040_R01";
import { HRM3040_R01_SCOPE_LIST } from "./Util_HRM3040_R01";

/** 기준일·표시·미리보기 사업장·부서 검색 영역을 반환한다. 별도 화면 버튼은 없다. */
export const HRM3040_R01SearchSection = () => {
    // Store Hook에서 현재 조건과 변경 함수를 읽는다.
    const {
        HRM3040_R01Filter, // 현재 입력 중인 검색 조건
        setHRM3040_R01Filter, // 현재 검색 조건을 변경하는 함수
    } = useHRM3040_R01Store();
    // 공통 초기 조회에서 가져온 사업장·부서 목록을 재사용한다.
    const { compCdList, orgCdList } = useCommonCodeStore();
    // true이면 기준일 날짜 선택기를 펼친다.
    const [visible, setVisible] = useState(false);
    // 공통 날짜 선택기가 표시될 위치이다.
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
    /** 선택한 현지 날짜를 HRM2010과 같은 YYYY-MM-DD 문자열로 저장한다. 반환값은 없다. */
    const setBaseDate = (date: Date | undefined) => {
        if (!date) return;
        const year = date.getFullYear(); // 선택 연도
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 두 자리 월
        const day = String(date.getDate()).padStart(2, '0'); // 두 자리 일
        setHRM3040_R01Filter({ baseDt: `${year}-${month}-${day}` });
    };
    return (
        <SearchSectionForm>
            {/* 공통 날짜 선택기에 기준일과 펼침 위치를 연결한다. */}
            <SearchDateSingleForm label="기준일자" visible={visible} setVisible={setVisible}
                value={HRM3040_R01Filter.baseDt ? new Date(`${HRM3040_R01Filter.baseDt}T00:00:00`) : undefined}
                onChange={setBaseDate} pickerPosition={pickerPosition} setPickerPosition={setPickerPosition} />
            {/* 빈 값은 기존 공통 옵션인 '전체'로 표시하며 전체 이력을 요청한다. ?.·??는 항목이 없으면 빈 값을 저장한다. */}
            <SearchDropDownForm label="표시" value={HRM3040_R01Filter.scope} optionList={HRM3040_R01_SCOPE_LIST}
                onChangeItem={item => setHRM3040_R01Filter({ scope: item?.minorCd ?? '' })}
                wrapperOption={{ wrapperStyle: 'w-[240px] min-w-[240px] mr-[10px]', titleStyle: 'w-[45px] min-w-[45px]', selectStyle: 'w-[160px] min-w-[160px]' }} />
            {/* 사업장과 부서는 미리보기에만 적용한다. */}
            <SearchDropDownForm label="사업장" value={HRM3040_R01Filter.compCd} optionList={compCdList}
                onChangeItem={item => setHRM3040_R01Filter({ compCd: item?.compCd ?? '' })} />
            <SearchDropDownForm label="부서" value={HRM3040_R01Filter.orgCd} optionList={orgCdList}
                onChangeItem={item => setHRM3040_R01Filter({ orgCd: item?.orgCd ?? '' })} />
        </SearchSectionForm>
    );
};
